import Button, { ButtonProps } from "react-bootstrap/Button";
import styles from "./ControlButton.module.scss";
import getClasses from "utils/getClasses";

const ControlButton = ({ className, children, ...props }: ButtonProps) => (
  <Button
    className={getClasses(
      "rounded-circle shadow",
      styles["control-button"],
      props.disabled && styles["disabled"],
      className,
    )}
    {...props}
  >
    {children}
  </Button>
);

export default ControlButton;
